import React, { useState } from 'react';
import { supabase } from './supabase';

const C = { purple:"#691FB1", purpleLight:"#EDE7F6", red:"#FF357B", border:"#E4DEFA", textLight:"#8888AA", text:"#1A1A2E" };

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [modo, setModo] = useState('login'); // 'login' | 'reset'
  const [msg, setMsg] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError('Email ou password incorrectos.');
    setLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setMsg('');
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin });
    if (error) setError('Nao foi possivel enviar o email. Verifica o endereco.');
    else setMsg('Email enviado! Verifica a tua caixa de correio e segue o link para definir nova password.');
    setLoading(false);
  };

  return (
    <div style={{ minHeight:'100vh', background:'#F7F5FC', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:wght@700&display=swap" rel="stylesheet"/>
      <div style={{ background:'white', borderRadius:16, padding:40, width:380, boxShadow:'0 8px 40px rgba(105,31,177,0.12)' }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:48, height:48, background:C.purple, borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', fontFamily:"'Fraunces',serif", color:'white', fontWeight:700, fontSize:24 }}>W</div>
          <h1 style={{ margin:0, fontFamily:"'Fraunces',serif", color:C.purple, fontSize:24 }}><img src={process.env.PUBLIC_URL + '/logo-badge.png'} alt={''} style={{width:120,height:'auto',display:'block',margin:'0 auto 14px'}} />HUB Workwell</h1>
          <p style={{ margin:'8px 0 0', color:C.textLight, fontSize:13 }}>Gestão de Projetos</p>
        </div>
        <form onSubmit={modo==='login'?handleLogin:handleReset}>
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:12, fontWeight:600, color:C.textLight, display:'block', marginBottom:6 }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="nome@workwell.pt" required
              style={{ width:'100%', padding:'10px 12px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box', color:C.text }}/>
          </div>
          {modo==='login' && <div style={{ marginBottom:24 }}>
            <label style={{ fontSize:12, fontWeight:600, color:C.textLight, display:'block', marginBottom:6 }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required
              style={{ width:'100%', padding:'10px 12px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box', color:C.text }}/>
          </div>}
          {error && <div style={{ background:'#FFF0F5', border:'1px solid #FF357B', borderRadius:8, padding:'10px 12px', fontSize:13, color:'#BE1356', marginBottom:16 }}>{error}</div>}
          {msg && <div style={{ background:'#EAFAF1', border:'1px solid #27AE60', borderRadius:8, padding:'10px 12px', fontSize:13, color:'#1E8449', marginBottom:16 }}>{msg}</div>}
          <button type="submit" disabled={loading}
            style={{ width:'100%', padding:'12px', background:C.purple, border:'none', borderRadius:8, color:'white', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", opacity:loading?0.7:1 }}>
            {loading ? '...' : (modo==='login'?'Entrar':'Enviar email de recuperacao')}
          </button>
          <div style={{ textAlign:'center', marginTop:16 }}>
            {modo==='login'
              ? <button type="button" onClick={()=>{setModo('reset');setError('');setMsg('');}} style={{ background:'none', border:'none', color:C.purple, fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", textDecoration:'underline' }}>Esqueci-me da password</button>
              : <button type="button" onClick={()=>{setModo('login');setError('');setMsg('');}} style={{ background:'none', border:'none', color:C.textLight, fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>&larr; Voltar ao login</button>
            }
          </div>
        </form>
      </div>
    </div>
  );
}
